import type { LocalizedText } from "../../app/i18n/i18n";
import { CYCLE_UNIT_CONTRACT_PERIOD,CYCLE_UNIT_DAILY,CYCLE_UNIT_MONTHLY,CYCLE_UNIT_ONE_TIME,CYCLE_UNIT_WEEKLY,CYCLE_UNIT_YEARLY } from "../../app/constants/cycleUnit";

export function restPeriodFeeCycleUnitForAmountUnit(value?: number | string | null): number {
  const unit = value != null ? Number(value) : CYCLE_UNIT_MONTHLY;
  if (unit === CYCLE_UNIT_ONE_TIME || unit === CYCLE_UNIT_WEEKLY || unit === CYCLE_UNIT_YEARLY) return unit;
  return CYCLE_UNIT_MONTHLY;
}

/** Importierte Einmalpauschalen besitzen häufig noch keine explizite Betragseinheit. */
export function restPeriodFeeAmountUnit(value: { feeAmountUnit?: number | null; feeCycleUnit?: number | null }): number {
  return value.feeAmountUnit ?? (value.feeCycleUnit === CYCLE_UNIT_ONE_TIME ? CYCLE_UNIT_ONE_TIME : CYCLE_UNIT_MONTHLY);
}

export function restPeriodFeeUnitText(unit: number | null | undefined, text: (value: LocalizedText) => string): string {
  switch (unit) {
    case CYCLE_UNIT_ONE_TIME:
      return text("One-time");
    case CYCLE_UNIT_DAILY:
      return text("per day");
    case CYCLE_UNIT_WEEKLY:
      return text("per week");
    case CYCLE_UNIT_MONTHLY:
      return text("per month");
    case CYCLE_UNIT_YEARLY:
      return text("per year");
    case CYCLE_UNIT_CONTRACT_PERIOD:
      return text("per contribution period");
    default:
      return text("per month");
  }
}
